import React from 'react';
import {useConsent} from '../../ConsentContext';
import './Footer.css';
import {HashLink as Link} from "react-router-hash-link";
import logo from "../../resources/images/logo_500_500.png";
import ButtonMailTo from "../Buttons/ButtonMailTo";
import ButtonCallTo from "../Buttons/ButtonCallTo";

function Footer() {
    const {setSettingsOpen} = useConsent();
    return (
        <div className='footer-container'>
            <div className='footer-links'>
                <div className='footer-link-wrapper'>
                    <div className='footer-link-items'>
                        <h2>Contact Us</h2>
                        <ButtonMailTo mailto={'mailto:mail@bioretis.com'} label={'mail@bioretis.com'} />
                        <ButtonCallTo tel={"+49 33793610022"} label={"+49 3379 3610022"} />
                    </div>
                </div>
                <div className='footer-link-wrapper'>
                    <div className='footer-link-items'>
                        <h2>Legal</h2>
                        <Link to='/legal-notice'>Legal Notice</Link>
                        <Link to='/privacy'>Privacy</Link>
                        <button type="button" className="footer-cookie-settings" onClick={() => setSettingsOpen(true)}>Cookie Settings</button>
                    </div>

                </div>
            </div>
            <section className='social-media'>
                <div className='social-media-wrap'>
                    <div className='footer-logo'>
                        <Link to='/#home' className='social-logo'>
                                <img src={logo} alt="Logo" width={"50px"}/>
                                <h5>BioRetis</h5>
                        </Link>
                    </div>
                    <small className='website-rights'>© Copyright BioRetis GmbH 2021-2026</small>
                </div>
            </section>
        </div>
    );
}

export default Footer;